// eslint-disable-next-line @alto/no-pocky-import
import { Paragraph, spacing } from '@alto/pocky';
import styled from 'styled-components';
import EmptyStateBox from '~web/features/app/components/EmptyStateBox';

export const StyledParagraph = styled(Paragraph)`
  margin-bottom: ${spacing.mdSpacing};
`;
export default EmptyStateBox;
